module.exports = __webpack_public_path__ + "static/media/Khazix.cd5e65eb.png";